
define('modules/application/wizard/classes/sirens',[
  "app",

  // Libs
  "backbone",

  //Classes
  "./genericIncrementalElement"

],

function(app, Backbone, genericIncrementalElement) {

  var sirens   = _.extend({}, genericIncrementalElement, {

    Views : {
      titleBar  : genericIncrementalElement.Views.titleBar.extend({

        setLabel                      : function() {
          if(this.model){
            var externalSirens      = this.model.get("externalSirens"),
                internalSirens      = this.model.get("internalSirens"),
                externalSirensValue = 0;
            if(externalSirens || internalSirens)
              this.$el.children(".titleBarcontent").html($.i18n._("IDS_WAI8_2")+"<span class=\"caption\"></span>");

            if(externalSirens)
              for(var i=0; i<externalSirens.length; i++)
                externalSirensValue += externalSirens[i].value;

            if (((externalSirensValue>0)||(internalSirens.value>0)) && internalSirens.enabled)
            {
              var externalSirensLabel, internalSirensLabel;

              if (this.model.get("externalSirens")[0].partOfKit)
                externalSirensLabel = "<span style='margin:0px; padding: 0px; float: left; color:#a0a2a3;'>"+externalSirensValue+ " " +$.i18n._("IDS_WAI2_403")+" (KIT) -&nbsp;</span>";
              else
                externalSirensLabel = "<span style='margin:0px; padding: 0px; float: left;'>"+externalSirensValue+ " " +$.i18n._("IDS_WAI2_403")+ " -&nbsp;</span>";

              internalSirensLabel = "<span style='margin:0px; padding: 0px; float: left;'>" + internalSirens.value + " " +$.i18n._("IDS_WAI2_407")+ "</span>";

              this.$el.find(".titleBarcontent span").append(externalSirensLabel + internalSirensLabel);
              this.$el.find(".titleBarcontent span").fadeIn(200);
            }
            else
            {
              this.$el.find(".titleBarcontent span").fadeOut(200);
            }
          }
        },
        afterRender:function(){
          this.setLabel();
        }
      }),

      content   : genericIncrementalElement.Views.content.extend({
        template  : "application/wizard/sections/sirens/content",
        events: _.extend({
          'click .externalSirens#siren-0 .ui-spinner-up': 'incrementFirstExternalSirensValue',
          'click .externalSirens#siren-0 .ui-spinner-down': 'decrementFirstExternalSirensValue',
          'click .externalSirens#siren-1 .ui-spinner-up': 'incrementSecondExternalSirensValue',
          'click .externalSirens#siren-1 .ui-spinner-down': 'decrementSecondExternalSirensValue',
          'click .internalSirens .ui-spinner-up': 'incrementInternalSirensValue',
          'click .internalSirens .ui-spinner-down': 'decrementInternalSirensValue',
          'click .toggleInfoButton': 'toggleInfos'
        }, genericIncrementalElement.Views.content.prototype.events),

        serialize       : function() {return {model : this.model, app : app};},
        initialize      : function() {
          genericIncrementalElement.Views.content.prototype.initialize.apply(this);
          this.model.unbind("updateViews", this.render);
          this.model.bind("updateViews", this.render, this);
        },

        toggleInfos : function(e) {
          return genericIncrementalElement.Views.content.prototype.toggleInfos(e, this);
        },


        decrementFirstExternalSirensValue                : function() {
          this.model.decrementExternalSirensValue(0);
        },

        decrementSecondExternalSirensValue                : function() {
          this.model.decrementExternalSirensValue(1);
        },

        incrementFirstExternalSirensValue           : function() {
          this.model.incrementExternalSirensValue(0);
        },

        incrementSecondExternalSirensValue          : function() {
          this.model.incrementExternalSirensValue(1);
        },

        decrementInternalSirensValue                : function() {
          if (this.model.get("enabled"))
            this.model.decrementInternalSirensValue();
        },

        incrementInternalSirensValue                : function() {
          if (this.model.get("enabled"))
            this.model.incrementInternalSirensValue();
        },

        disableSection                 : function() {
          if (!this.model.get("enabled"))
          {
            this.$el.find(".externalSirens").addClass("disabled");
            this.$el.find(".internalSirens").addClass("disabled");
          }
        },

        enableSection                  : function() {
          if (this.model.get("enabled"))
          {
            this.$el.find(".externalSirens").removeClass("disabled");
            this.$el.find(".internalSirens").removeClass("disabled");
          }
        },

        showDetails: function() {
          this.$el.find(".exampleImage").fadeIn(200);
          this.$el.find(".productCode").fadeIn(200);
          this.$el.find(".description").fadeIn(200);
          this.$el.find(".linkContainer").fadeTo(200,1);
        },

        hideDetails: function() {
          this.$el.find(".exampleImage").fadeOut(200, function() {$(this).hide();});
          this.$el.find(".productCode").fadeOut(200, function() {$(this).hide();});
          this.$el.find(".description").fadeOut(200, function() {$(this).hide();});
          this.$el.find(".linkContainer").fadeTo(200,0);
        },

        updateSpinners                 : function() {
          var externalSirensModel  = _.extend({}, this.model.get("externalSirens"));
          var internalSirensModel  = _.extend({}, this.model.get("internalSirens"));
          this.$el.find(".externalSirensSpinner .spinner").html(externalSirensModel.value);
          this.$el.find(".internalSirensSpinner .spinner").html(internalSirensModel.value);

          if (!externalSirensModel.enabled)
            this.$el.find(".externalSirensSpinner").addClass("disabled");
          else
            this.$el.find(".externalSirensSpinner").removeClass("disabled");

          if (!internalSirensModel.enabled)
            this.$el.find(".internalSirensSpinner").addClass("disabled");
          else
            this.$el.find(".internalSirensSpinner").removeClass("disabled");

          if ((!externalSirensModel.enabled)&&(!internalSirensModel.enabled))
            this.hideDetails();
          else
            this.showDetails();
        }
      })
    },

    Model       : genericIncrementalElement.Model.extend({

      defaults                 :  _.extend({}, genericIncrementalElement.Model.prototype.defaults, {
        externalSirens : [
          {
            enabled         : false,
            value           : 0,
            minValue        : 0,
            maxValue        : 2,
            packageClassId : ""
          },
          {
            enabled         : false,
            value           : 0,
            minValue        : 0,
            maxValue        : 2,
            packageClassId : ""
          }
        ],
        internalSirens : {
          enabled         : false,
          value           : 0,
          minValue        : 0,
          maxValue        : 3,
          packageClassId : "4203"
        }
      }),

      initialize                    :  function()             {

        this.set("name", "IDS_WAI8_2");

        window.BticinoS4B.eventAggregator.unbind("load:Project",    this.loadProject);
        window.BticinoS4B.eventAggregator.bind("load:Project",    this.loadProject, this);

        //Bind on materials overview model delivery request
        window.BticinoS4B.eventAggregator.unbind("modelDeliver:request",this.deliverModel);
        window.BticinoS4B.eventAggregator.bind("modelDeliver:request",this.deliverModel, this);

        this.unbind("change:externalSirens", this.sirensModelChanged);
        this.bind("change:externalSirens", this.sirensModelChanged, this);
        this.unbind("change:internalSirens", this.sirensModelChanged);
        this.bind("change:internalSirens", this.sirensModelChanged, this);

        //Bind on accessory line  selection
        window.BticinoS4B.eventAggregator.unbind("accessoryLine:chosen",                this.accessoryLineChosenEventHandler);
        window.BticinoS4B.eventAggregator.bind("accessoryLine:chosen",                  this.accessoryLineChosenEventHandler, this);

        //Bind on power supply selection
        this.attributes.stepEventAggregator.unbind('powerSupply:chosen',  this.powerSupplyChosenEventHandler);
        this.attributes.stepEventAggregator.bind('powerSupply:chosen',    this.powerSupplyChosenEventHandler, this);

        //Bind on power supply removal
        this.attributes.stepEventAggregator.unbind('powerSupply:removed', this.powerSupplyRemovedEventHandler);
        this.attributes.stepEventAggregator.bind('powerSupply:removed',   this.powerSupplyRemovedEventHandler, this);

        window.BticinoS4B.eventAggregator.unbind("externalSirens:addedFromKit",         this.productAddedFromKitEventHandler);
        window.BticinoS4B.eventAggregator.bind("externalSirens:addedFromKit",           this.productAddedFromKitEventHandler, this);

        window.BticinoS4B.eventAggregator.unbind("removeKitItems",                      this.removeKitItems);
        window.BticinoS4B.eventAggregator.bind("removeKitItems",                        this.removeKitItems, this);

        window.BticinoS4B.eventAggregator.bind("currentDeliver:requested",              this.deliverCurrent, this);
      },

      productAddedFromKitEventHandler : function(addedExternalSirens) {
        var externalSirens                = this.get("externalSirens");
        externalSirens[0].partOfKit       = true;
        externalSirens[0].minValue        = addedExternalSirens.quantity;
        externalSirens[0].kitValue        = addedExternalSirens.quantity;

        if (externalSirens[0].value)
        {
          if (externalSirens[0].value<=externalSirens[0].minValue)
            externalSirens[0].value = addedExternalSirens.quantity;
        }
        else
          externalSirens[0].value = addedExternalSirens.quantity;

        externalSirens[0].packageClassId  = addedExternalSirens.externalSirens;

        this.set("externalSirens", externalSirens);
        this.trigger("updateViews");
      },

      accessoryLineChosenEventHandler : function() {
        var powerSupply = this.get("powerSupply");

        if (powerSupply)
          this.getPackages(powerSupply);
      },

      removeKitItems                : function() {

      },

      retrievePackages              : function() {
        this.getPackages();
      },

      powerSupplyChosenEventHandler : function(powerSupply)  {
        this.set("powerSupply", powerSupply);
        this.retrievePackages();
      },

      powerSupplyRemovedEventHandler:  function()             {
        var externalSirensModel = this.get("externalSirens");
        var internalSirensModel = this.get("internalSirens");

        for (var i=0, externalSirensLength = externalSirensModel.length; i<externalSirensLength; i++)
          externalSirensModel[i].enabled=false;

        internalSirensModel.enabled=false;
        this.set("externalSirens", externalSirensModel);
        this.set("internalSirens", internalSirensModel);
        this.trigger("updateViews");
      },

      sirensModelChanged            :  function()             {
        this.trigger("updateViews");
      },

      deliverModel                  :  function()             {
        var externalItems, externalSirens = this.get("externalSirens"), internalSirens = this.get("internalSirens");
        var dataProvider = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider");
        var i=0, j=0;

          switch (BticinoS4B.vars.system.id) {
            case '#2':
              BticinoS4B.solution.thermoregulation.sirens = this;
              break;
            case '#4':
              BticinoS4B.solution.intrusionDetection.sirens = this;
              break;
            case '#5+6':
              BticinoS4B.solution.audioVideo.sirens = this;
              break;
            case '#13+20':
              BticinoS4B.solution.automation.sirens = this;
              break;
            case '#13':
              BticinoS4B.solution.automationSimple.sirens = this;
              break;
            case '#21':
              BticinoS4B.solution.energyManagement.sirens = this;
              break;
          }
          
        BticinoS4B.Instances.Models.ApplicationModel.set("sirens", this);

        externalItems = BticinoS4B.Instances.Models.ApplicationModel.get("externalItems");

        for (i=0; i<externalSirens.length; i++)
        {
          if (externalSirens[i].enabled)
          {
            dataProvider.addItems("externalItems", {
              productCode       : externalSirens[i].productCode,
              productLabel      : externalSirens[i].productLabel,
              packageClassLabel : externalSirens[i].packageClassLabel,
              kitValue          : externalSirens[i].kitValue,
              partOfKit         : externalSirens[i].partOfKit,
              quantity          : externalSirens[i].value,
              price             : externalSirens[i].price
            });

            if ((externalSirens[i].secondaryProducts)&&(externalSirens[i].secondaryProducts.length>0)) {
              for (j=0; j<externalSirens[i].secondaryProducts.length; j++) {
                dataProvider.addItems("externalItems", {
                  productCode       : externalSirens[i].secondaryProducts[j].productCode,
                  productLabel      : externalSirens[i].secondaryProducts[j].productLabel,
                  packageClassLabel : externalSirens[i].secondaryProducts[j].packageClassLabel,
                  kitValue          : externalSirens[i].kitValue,
                  partOfKit         : externalSirens[i].partOfKit,
                  quantity          : externalSirens[i].value,
                  price             : externalSirens[i].secondaryProducts[j].price
                });
              }
            }
          }
        }

        dataProvider.addItems("externalItems", {
          productCode       : internalSirens.productCode,
          productLabel      : internalSirens.productLabel,
          packageClassLabel : internalSirens.packageClassLabel,
          quantity          : internalSirens.value,
          price             : internalSirens.price
        });

        if ((internalSirens.secondaryProducts)&&(internalSirens.secondaryProducts.length>0)) {
          for (i=0; i<internalSirens.secondaryProducts.length; i++) {
            dataProvider.addItems("externalItems", {
              productCode       : internalSirens.secondaryProducts[i].productCode,
              productLabel      : internalSirens.secondaryProducts[i].productLabel,
              packageClassLabel : internalSirens.secondaryProducts[i].packageClassLabel,
              quantity          : internalSirens.value,
              price             : internalSirens.secondaryProducts[i].price
            });
          }
        }


      },

      incrementExternalSirensValue  :  function(sirenPosition){
        var firstExternalSirensModel   = this.get("externalSirens")[0],
            secondExternalSirensModel  = this.get("externalSirens")[1],
            externalSirensModel        = this.get("externalSirens")[sirenPosition],
            internalSirensModel        = this.get("internalSirens"),
            maxSirens                  = this.get("maxSirens");

        if (externalSirensModel.enabled)
        {
          if ((externalSirensModel.value+1)<=externalSirensModel.maxValue) {
            if ((firstExternalSirensModel.value+secondExternalSirensModel.value+internalSirensModel.value+1)<=maxSirens)
              externalSirensModel.value = externalSirensModel.value+1;

            this.trigger("updateViews");

            //Update currents consumption indicator
            window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
          }
          return externalSirensModel.value;
        }
        else
          return null;
      },

      decrementExternalSirensValue  :  function(sirenPosition){
        var externalSirensModel  = this.get("externalSirens")[sirenPosition];

        if (externalSirensModel.enabled)
        {
          if ((externalSirensModel.value-1)>=externalSirensModel.minValue)
          {
            externalSirensModel.value = externalSirensModel.value-1;
            this.trigger("updateViews");

            //Update currents consumption indicator
            window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
          }
          return this.get("interfaceValue");
        }
        else
          return null;
      },

      incrementInternalSirensValue  :  function()             {
        var firstExternalSirensModel   = this.get("externalSirens")[0],
            secondExternalSirensModel  = this.get("externalSirens")[1],
            internalSirensModel        = this.get("internalSirens"),
            maxSirens                  = this.get("maxSirens");

        if (internalSirensModel.enabled)
        {
          if ((internalSirensModel.value+1)<=internalSirensModel.maxValue)
          {
            if ((firstExternalSirensModel.value+secondExternalSirensModel.value+internalSirensModel.value+1)<=maxSirens)
              internalSirensModel.value = internalSirensModel.value+1;

            this.set("internalSirens", internalSirensModel);
            this.trigger("updateViews");

            //Update currents consumption indicator
            window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
          }
          return internalSirensModel.value;
        }
        else
          return null;
      },

      decrementInternalSirensValue  :  function()             {
        var internalSirensModel  = _.extend({}, this.get("internalSirens"));
        if (internalSirensModel.enabled)
        {
          if ((internalSirensModel.value-1)>=internalSirensModel.minValue)
          {
            internalSirensModel.value = internalSirensModel.value-1;
            this.set("internalSirens", internalSirensModel);
            this.trigger("updateViews");

            //Update currents consumption indicator
            window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
          }
          return internalSirensModel.value;
        }
        else
          return null;
      },

      getPackages                   :  function()  {
        var that                          = this,
            accessoryLineId               = BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId"),
            powerSupply                   = this.get("powerSupply"),
            requiredExternalSirens        = powerSupply.get("specialVars").externalSirens,
            requiredExternalSirensLength  = 0,
            externalSirensModel           = this.get("externalSirens"),
            internalSirensModel           = this.get("internalSirens"),
            currentModelToLoad                   = this.get("loadedModel"),
            i                             = 0;
            
        if(requiredExternalSirens!==undefined)
          requiredExternalSirensLength  = requiredExternalSirens.length;

        if (accessoryLineId!==undefined)
        {
          if (powerSupply.get("specialVars").maxSirens)
          {
            this.set("maxSirens", powerSupply.get("specialVars").maxSirens);
          }

          //Resetting values
          externalSirensModel[0].value=0;
          externalSirensModel[1].value=0;
          internalSirensModel.value=0;

          var packagesRetrievedCallback = function(data) {
            data.specialVars = JSON.parse(data.specialVars);

            //Sorting elements by packageClassId
            that.fetchedSirens = data;

            var currentpackageClassid = "-1";

            if (currentpackageClassid !== that.fetchedSirens.packageClassId)
              currentpackageClassid = that.fetchedSirens.packageClassId;
            else {
              that.fetchedSirens.splice(i, 1);
              i--;
            }

            //_.extend(that.attributes, that.fetchedSirens[0]);
            _.extend(externalSirensModel[i], that.fetchedSirens);

            //Retrieving product details
            BticinoS4B.Instances.Models.ApplicationModel.getProducts(externalSirensModel[i].packageClassId, productsRetrievedCallback);
          };

          var productsRetrievedCallback = function(data) {
            data.products = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
            var products  = _.filter(data.products,function(product) {return ((product.mnemonic===1));});

            if (products.length>0)
              products = products[0];

            _.extend(externalSirensModel[i], products);
            externalSirensModel[i].enabled = true;

            var secondaryProducts;
            var secondaryProductsToPush = [];

            secondaryProducts = _.filter(data.products,function(product) {return (product.mnemonic!==1);});

            externalSirensModel[i].secondaryProducts = secondaryProducts;
            externalSirensModel[i].enabled           = true;
            externalSirensModel[i].value             = powerSupply.get("specialVars").minExternalSirens;
            externalSirensModel[i].minValue          = powerSupply.get("specialVars").minExternalSirens;
            externalSirensModel[i].maxValue          = powerSupply.get("specialVars").maxExternalSirens;

          };

          //Assigning the correct siren's packageClassId based on the selected power supply
          for (i=0; i<requiredExternalSirensLength; i++)
            externalSirensModel[i].packageClassId = requiredExternalSirens[i];

          //Retrieving external sirens
          for (i=0; i<requiredExternalSirensLength; i++)
            if (externalSirensModel[i].packageClassId && externalSirensModel[i].packageClassId!=="")
              BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass(externalSirensModel[i].packageClassId, packagesRetrievedCallback);

          for (i=requiredExternalSirensLength; i<externalSirensModel.length; i++)
            externalSirensModel[i].enabled                 = false;

          //Retrieving internal sirens
          BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass(internalSirensModel.packageClassId, function(data) {
            //Sorting elements by packageClassId
            that.fetchedSirens = data;

            var currentpackageClassid = "-1";

            if (currentpackageClassid!==that.fetchedSirens.packageClassId)
              currentpackageClassid = that.fetchedSirens.packageClassId;
            else
            {
              that.fetchedSirens.splice(i,1);
              i--;
            }

            _.extend(internalSirensModel, that.fetchedSirens);

            //Retrieving product details
            BticinoS4B.Instances.Models.ApplicationModel.getProducts(internalSirensModel.packageClassId, function(data) {
              data.products         = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
              data.products         = _.filter(data.products,function(product) {return product.mnemonic==1;});
              if (data.products.length>0)
                data = data.products[0];
              _.extend(internalSirensModel, data);
              internalSirensModel.enabled = true;

              var secondaryProducts = _.filter(data.products,function(product) {return (product.mnemonic!==1);});

              internalSirensModel.secondaryProducts=secondaryProducts;
            });
          });

          /*If there's a loading process load the correct values*/
          if (currentModelToLoad) {
            externalSirensModel[0].value     = currentModelToLoad.externalSirens[0].value;
            externalSirensModel[0].partOfKit = currentModelToLoad.externalSirens[0].partOfKit;
            externalSirensModel[0].kitValue  = currentModelToLoad.externalSirens[0].kitValue;

            externalSirensModel[1].value     = currentModelToLoad.externalSirens[1].value;
            externalSirensModel[1].partOfKit = currentModelToLoad.externalSirens[1].partOfKit;
            externalSirensModel[1].kitValue  = currentModelToLoad.externalSirens[1].kitValue;

            internalSirensModel.value        = currentModelToLoad.internalSirens.value;
          }

          this.set("externalSirens", externalSirensModel);
          this.set("internalSirens", internalSirensModel);

          this.set("loadedModel", undefined);

          this.enableSection();
          this.trigger("updateViews");
        }
      },

      loadModel                     : function() {
        if((this.get("loadedModel") && this.get("loadedModel").externalSirens.length)||(this.get("loadedModel") && this.get("loadedModel").get("externalSirens").length)){
          for (var i = this.get("loadedModel").externalSirens.length - 1; i >= 0; i--)
            _.extend(this.attributes.externalSirens[i], this.get("loadedModel").externalSirens[i]);

          _.extend(this.attributes.internalSirens, this.get("loadedModel").internalSirens);
          this.set("loadedModel", undefined);
          this.trigger("render:requested");
          this.trigger("updateViews");
        }
      },

      loadProject                   :  function(model)        {
        this.set("loadedModel", model.sirens);
        this.loadModel();
      },

      deliverCurrent                : function() {
        var externalSirensModel              = this.get("externalSirens"),
            internalSirensModel              = this.get("internalSirens"),
            consumptionIndicatorModel        = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel"),
            externalSirensCurrentConsumption = 0,
            i                                = 0;

        if (externalSirensModel)
        {
          for(i=0; i<externalSirensModel.length; i++)
          {
            if (externalSirensModel[i].specialVars)
            {
              externalSirensCurrentConsumption = externalSirensModel[i].value*externalSirensModel[i].specialVars.currentConsumption;
              if (externalSirensCurrentConsumption<0)
                consumptionIndicatorModel.addSupplyCurrent(externalSirensCurrentConsumption);
              else
                consumptionIndicatorModel.addCurrentConsumption(externalSirensCurrentConsumption);
            }
          }
        }

        if ((internalSirensModel)&&(internalSirensModel.specialVars)) {
          var internalSirensCurrentConsumption = internalSirensModel.value*$.parseJSON(internalSirensModel.specialVars).currentConsumption;
          if (internalSirensCurrentConsumption<0)
            consumptionIndicatorModel.addSupplyCurrent(internalSirensCurrentConsumption);
          else
            consumptionIndicatorModel.addCurrentConsumption(internalSirensCurrentConsumption);
        }

      }

    })
  });

  // Required, return the module for AMD compliance
  return sirens;

});